module.exports = __webpack_public_path__ + "img/map-reduce.f474f043.svg";